import '../styles/css/Footer.css';
import React from 'react'

function Footer({className}) {
    return (
        <div className={className}>
           <p>Market</p>
        </div>
    )
}

export default Footer
